/**
 * 登录相关
 */
export default [
  {
    name: 'extLogin',
    method: 'post',
    url: '/auth/api/v1/common/ignore/silentSignIn',
  },
  {
    /**
     * 登录
     * http://10.222.95.129/#/view/jP81qB8q
     */
    name: 'doLogin',
    method: 'post',
    url: '/auth/oauth/applyToken',
  },
  {
    /**
     * 新登录发送短信
     *
     */
    name: 'authenticationSms',
    method: 'post',
    url: '/auth/page/login/noAuth/authenticationSms',
  },
  {
    /**
     * 修改密码发送短信
     *
     */
    name: 'loginVerification',
    method: 'post',
    url: '/auth/page/login/loginVerification',
  },
  {
    /**
     * 登录发送短信
     * http://10.222.95.129/#/view/r2jZ1M2G
     */
    name: 'queryLoginUserInfo',
    method: 'post',
    url: '/auth/oauth/noAuth/queryAuthInfo',
  },
  {
    /**
     * 功能描述: 重置短信密码
     * http://10.222.160.160:8080/#/view/Q2V7518e
     */
    name: 'resetLoginPassword',
    method: 'post',
    url: '/auth/page/login/noAuth/resetLoginPassword',
  },
  {
    /**
     * 查询登录用户信息
     * http://10.222.160.160:8080/#/view/BXgY5W2G
     */
    name: 'queryLoginInfo',
    method: 'post',
    url: '/auth/page/login/noAuth/queryLoginInfo',
  },
  {
    /**
     * 获取重置token
     * http://10.222.160.160:8080/#/view/aXYV5xzr
     */
    name: 'resetAuthentication',
    method: 'post',
    url: '/auth/page/login/noAuth/resetAuthentication',
  },
  {
    /**
     * 获取重置token
     * http://10.222.160.160:8080/#/view/aXYV5xzr
     */
    name: 'resetAuthenticationUpdate',
    method: 'post',
    url: '/auth/page/login/resetAuthentication',
  },
  {
    /**
     * 重置短信密码
     * http://10.222.160.160:8080/#/view/Q2V7518e
     */
    name: 'resetLoginPassword',
    method: 'post',
    url: '/auth/page/login/noAuth/resetLoginPassword',
  },
  {
    /**
     * 退出
     * http://10.222.160.160:8080/#/view/7zLQom2Q
     */
    name: 'loginOut',
    method: 'post',
    url: '/auth/oauth/loginOut',
  },
]
